<template>
  <div class="solution_box">
    <div class="banner">
      <div class="top">
        <div class="title">解决方案</div>
        <div class="titleSc">SOLUTIONS</div>
      </div>
      <img class="bannerimg" :src="$baseUrl + img_src.banner" alt="banner" />
    </div>
    <typebutton :current_type="current_type" :typeList="typeList" @checkType="checkType($event)"></typebutton>
    <!-- 内容 -->
    <div class="solution_content">
      <!-- 慢病管理解决方案 -->
      <div class="chronic_disease" v-if="current_type == 0">
        <div class="div_healthhouse">
          <p class="title">健康小屋</p>
          <br />
          <p>
            一体化健康小屋常见于社区卫生院内投放，方便辖区居民进入卫生院进行体检，这是“走进来”。健康小屋建设能提升社区医院开解，吸引居民体验签约，同时通过健康一体机能对居民进行健康检测。丰富健康小屋内容，能够提升居民对于签约服务的体验，同时在就诊高峰期也能指导等待就诊的居民进行体检，改善居民就医体验。
          </p>
          <img :src="$baseUrl+img_src.contentbg" width="900px" height="426px" alt
            style="margin-top: 40px; margin-bottom: 40px" />
        </div>
        <!-- 产品展示 -->
        <div class="product">
          <div class="product_left">
            <p class="title">健康一体机</p>
            <br />
            <p>
              一体化健康小屋常见于社区卫生院内投放，方便辖区居民进入卫生院进行体检，这是“走进来”。健康小屋建设能提升社区医院开解，吸引居民体验签约，同时通过健康一体机能对居民进行健康检测。丰富健康小屋内容，能够提升居民对于签约服务的体验，同时在就诊高峰期也能指导等待就诊的居民进行体检，改善居民就医体验。
            </p>
            <img :src="$baseUrl+img_src.yitijibg" width="456px" height="317px" alt style="margin-top: 40px" />
          </div>

          <div class="product_right">
            <p class="title">便携式随访检测仪</p>
            <br />
            <p>
              随访检测仪常见于社区基层卫生院、村卫生室，方便家庭医生进行上门随访体检，登记签约。这是“走出去”。乡镇卫生院可配置便携式随访检测仪，对居民进行移动随访。检测项目参照《国家基本公共卫生服务规范（第三版）》。广泛应用于省/市/县各级医院、社区服务站、乡镇卫生所、诊所、养老院等医疗卫生服务场所。
            </p>
            <img :src="$baseUrl+img_src.checkbackpack" width="346px" height="288px" alt style="margin-top: 40px" />
          </div>
        </div>
        <!-- 数值健康云平台 -->
        <div class="div_terrace">
          <div class="terrace">
            <p class="title">数字健康云平台</p>
            <br />
            <p>
              云平台基于公司研发的所有终端之上拓展研发出用户APP端、医生工作端和数字云健康管理平台为患者提供最全面的体检和干预治疗等一系列关于慢病防范的功能和服务。
            </p>
            <img :src="$baseUrl+img_src.healthterrace" width="620px" height="487px" alt style="margin-top: 40px" />
          </div>
        </div>
        <!-- ================================ -->
        <div class="div_terrace2">
          <img :src="$baseUrl+img_src.healthterrace2" width="1600px" alt style="margin-top: 40px" />
        </div>
        <!-- 公众号 -->
        <div class="div_terrace">
          <div class="terrace">
            <p class="title">微信公众号应用</p>
            <br />
            <p>
              居民自助体检后，可以通过公众号随时查看体检报告，遇到问题可以在线咨询责任医生。
            </p>
            <img :src="$baseUrl+img_src.gongzonbg" width="1010px" height="447px" alt style="margin-top: 40px" />
          </div>
        </div>
      </div>
      <!-- 动态心电监测解决方案 -->
      <div class="div_outerecg" v-if="current_type == 1">
        <div class="ecg">
          <p class="title">柔性心电体温贴</p>
          <br />
          <p>
            本产品采用单片机制成的心电图测量仪。其优点有灵敏度高、易于操作、响应速度快、结构简单；自主研发的AI+ECG智能心电算法、分布式存储系统、协同分析软件及心电采集设备于一体的整体解决方案,为医疗机构和院外用户提供心血管数据预处理的智能心电解决方案。高效率地处理心电数据。从而帮助中心医院提高诊断效率和治疗质量,帮助基础医院实现心电诊断能力,帮助患者连接医生,实现“早筛查、早预防、早治疗”。
            <br />
            <br />适用于心脏不适，如心慌、胸闷等人群，心率失常，心血管疾病，服用心脏药物，亚健康人群的心电监测及监护。
          </p>
          <div class="div_ecg">
            <img :src="$baseUrl+img_src.hnecg" width="420px" height="659px" alt />
            <img :src="$baseUrl+img_src.normalecg" style="margin-left: 85px" width="420px" height="659px" alt />
          </div>
        </div>
        <img :src="$baseUrl+img_src.selfecg" style="margin-top: 130px; margin-bottom: 70px" width="100%" height="1215px" alt />
        <!-- 动态心电心电监测小程序 -->
        <div class="ecg_smallprogm">
          <p class="title">心电监测小程序</p>
          <br />
          <p>
            亲情关怀：最多可添加五名家庭成员，爸妈与子女绑定同一设备，即可随时查看家人的检测记录，如有异常时，也能及时收到提醒心“联”心，给家人贴心的陪伴。
          </p>
          <img :src="$baseUrl+img_src.samllprogram" width="1260px" height="612px" alt style="margin-top: 40px" />
        </div>
        <!-- 动态心电心电监测小程序 -->
        <div class="ecg_smallprogm">
          <p class="title">柔性心电体温贴流程图</p>
          <br />
          <img :src="$baseUrl+img_src.ecgstep" width="1221px" height="396px" alt style="margin-top: 40px" />
        </div>
      </div>
      <!-- 医疗耗材管理解决方案 -->
      <div class="div_consumable" v-if="current_type == 2">
        <div class="consumable">
          <p class="title">医疗耗材管理当下的痛点</p>
          <div class="pain_point">
            <div class="point">
              <p class="point_title">01 管理</p>
              <p class="point_content">
                •
                物资品规多、供应商多，专业性强，采购量大，质控要求高，流通环节多，管理难度增加；
                <br />•
                医学专业人员兼职非医学专业的工作（计划申报、物资申领、仓储管理等）；
                <br />• 缺乏有效的工具支撑，库房溢库与缺货并存； <br />•
                无科学合理的手段评判科室消耗合理性，浪费情况时有发生；
              </p>
            </div>
            <div class="point">
              <p class="point_title">02 效率</p>
              <p class="point_content">
                • 科室供应场景多样化，各环节割裂独立管理，数据孤岛产生重复工作
                ；
                <br />•
                院内、院外采用传统协作方式，效率低，误配、漏配、延迟配送等情况时有发生；
                <br />•
                手工线下纸质配合，环节众多，衔接过程中存在信息传递失真，易出错；
                <br />•
                缺少工具支持，科室补货需求、采购需求、数据统计需求等等都需要人工手动管理，过程繁琐；
              </p>
            </div>
            <div class="point">
              <p class="point_title">03 成本</p>
              <p class="point_content">
                • 药品、耗材零加成后，医院不得不承担各项物资的管理成本；
                <br />•
                传统模式下，物资效期监管工作量大，不可避免的产生了损耗浪费；
                <br />•
                科室医护人员忙于医疗服务，因错拿形成的不恰当使用，造成“跑冒滴漏”产生；
                <br />•
                从财务的角度，医院在供应过程中，因库房储存，产生了大量的库存资金积压，而在带量采购趋势下，无形中产生了成本浪费；
              </p>
            </div>
          </div>
        </div>
        <!-- 国家相关政策 -->
        <div class="div_policy">
          <div class="policy">
            <p class="title">国家相关政策</p>
            <br />

            <img :src="$baseUrl+img_src.policybg" width="1200px" height="520px" alt style="margin-bottom: 50px" />
            <p style="color: #202020; font-size: 22px">
              行业政策驱使医院探索降本增效、精细化管理新方案
            </p>
          </div>
        </div>
        <!-- 医疗耗材解决方案 -->
        <div class="consumable_solution">
          <p class="title">医耗管理智慧精细化解决方案</p>
          <br />
          <p>
            玉鸿图医耗智慧管理由玉鸿图医耗管理系统软件与玉鸿图医耗智能化管理装备构成。玉鸿图医疗充分发挥信息软件研发与装备设计制造一体化优势，发明创新，行业首次实现医院耗材管理的智能化装备系统应用闭环，将医院耗材管理推进新的领域。玉鸿图医疗充分发挥信息软件研发与装备设计制造一体化优势，发明创新，行业首次实现医院耗材管理的智能化装备系统应用闭环，将医院耗材管理推进新的领域。
          </p>
          <img :src="$baseUrl+img_src.consumablebg" width="900px" height="420px" alt
            style="margin-bottom: 30px; margin-top: 40px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import typebutton from "../components/typebutton.vue";
// import 'swiper/swiper-bundle.css'
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
    SwiperSlide,
    typebutton,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      img_src: {
        banner: "/upload-router-api/personPhoto/2024/11/13/1731458251331168476.png",
        contentbg: "/upload-router-api/personPhoto/2024/11/13/1731485939572270865.png",
        checkbackpack: "/upload-router-api/personPhoto/2024/11/12/1731395160487079723.png",
        healthterrace: "/upload-router-api/personPhoto/2024/11/12/1731395267494845674.png",
        policybg: "/upload-router-api/personPhoto/2024/11/12/1731395768557667996.png",
        yitijibg: "/upload-router-api/personPhoto/2024/11/12/1731395226677472482.png",
        healthterrace2: "/upload-router-api/personPhoto/2024/11/12/1731395298454777734.png",
        gongzonbg: "/upload-router-api/personPhoto/2024/11/12/1731395322529857927.png",
        consumablebg: "/upload-router-api/personPhoto/2024/11/12/1731395809257633866.png",
        //=======心电图片============
        hnecg: "/upload-router-api/personPhoto/2024/11/12/1731395593420572049.png",
        normalecg: "/upload-router-api/personPhoto/2024/11/12/1731395610202294866.png",
        ecgstep: "/upload-router-api/personPhoto/2024/11/12/1731395691672327271.png",
        selfecg: "/upload-router-api/personPhoto/2024/11/12/1731395647640870402.png",
        samllprogram: "/upload-router-api/personPhoto/2024/11/12/1731395714971759524.png",
      },
      typeList: [
        { title: "慢病管理解决方案" },
        { title: "动态心电监测解决方案" },
        { title: "医疗耗材管理解决方案" },
      ],
      current_type: 0,
    };
  },

  watch: {
    "$route.query.current_type": {
      handler: function (option, data) {
        console.log(option);
        console.log(data);
        // console.log('222222222222222');
        this.current_type = Number(this.$route.query.current_type);
        //do something
      },
    },
  },
  created() {
    this.current_type = Number(this.$route.query.current_type)
      ? Number(this.$route.query.current_type)
      : 0;
  },
  methods: {
    checkType(index) {
      console.log("22222");
      this.current_type = index;
      console.log(index);
    },
  },
};
</script>

<style lang="less" scope>
.solution_box {
  .banner {
    min-width: 1200px;
    margin-bottom: 30px;
    position: relative;

    .bannerimg {
      width: 100%;
      height: 500px;
    }

    .top {
      position: absolute;
      top: 262px;
      left: 423px;
      color: #fff;

      .title {
        font-size: 48px;
        line-height: 12px;
        color: #ffffff;
      }

      .titleSc {
        font-size: 28px;
        line-height: 12px;
        color: #ffffff;
        margin-top: 60px;
      }
    }
  }

  //内容
  .solution_content {
    width: 100%;
    margin-bottom: 40px;

    .title {
      color: #333333;
      text-align: center;
      font-size: 24px;
      font-weight: bold;
    }

    p {
      color: #474747;
      font-size: 14px;
      line-height: 30px;
    }

    // 慢病管理
    .chronic_disease {
      padding-top: 40px;
      display: flex;
      flex-direction: column;
      margin: 0 auto;

      .div_healthhouse {
        width: 900px;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
      }

      //产品
      .product {
        margin-top: 80px;
        padding: 80px 0;
        width: 100%;
        background: #f5f5f5;
        display: flex;
        justify-content: center;

        .product_left {
          width: 600px;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 520px;
        }

        .product_right {
          margin-left: 120px;
          width: 600px;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 520px;
        }
      }

      //健康云平台
      .div_terrace {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .terrace {
          padding: 80px 0;
          width: 1000px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }

      .div_terrace2 {
        width: 100%;
        display: flex;
        justify-content: center;
        background: #f5f5f5;
        align-items: center;
      }
    }

    // 动态心电监测解决方案
    .div_outerecg {
      padding-top: 40px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .ecg {
        width: 900px;
        display: flex;
        flex-direction: column;
        margin: 0 auto;

        .div_ecg {
          margin-top: 100px;
          display: flex;
          justify-content: center;
        }
      }

      //动态心电里的心电小程序/柔性心电体温贴流程图（共用样式）
      .ecg_smallprogm {
        margin-bottom: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }

    // 医疗耗材管理解决方案
    .div_consumable {
      padding-top: 40px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 0 auto;

      .consumable {
        padding-top: 40px;
        width: 1000px;
        display: flex;
        flex-direction: column;
        margin: 0 auto;

        .pain_point {
          margin-top: 50px;
          display: flex;
          justify-content: center;
          align-items: center;

          .point {
            padding: 30px 30px;
            width: 340px;
            height: 340px;
            margin: 0 10px;
            background: #f2f2ff;
          }

          .point:hover {
            cursor: pointer;
            background: #2525cc;

            .point_content {
              color: white;
            }

            .point_title {
              color: white;
            }
          }

          .point_title {
            color: #333333;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
          }

          .point_content {
            margin-top: 20px;
            color: #474747;
            font-size: 12px;
            line-height: 26px;
          }
        }
      }

      //政策
      .div_policy {
        margin-top: 80px;
        width: 100%;
        display: flex;
        background: #ebebeb;
        justify-content: center;
        align-items: center;

        .policy {
          padding: 80px 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      }

      //医疗耗材
      .consumable_solution {
        width: 900px;
        padding: 80px 0;
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Solutions.vue